import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/images/logos/edu-logo.png";
import eeaio from "../../assets/images/eeaio.png";
import useStore from "../../store/information";

const Footer = (props) => {
  const {  footerClass } = props;
  const { totalInfo } = useStore();
  const [data, setData] = useState({});

  useEffect(() => {
    if (totalInfo) {
      const ph1 = localStorage.getItem('ph1');
   
      const email = localStorage.getItem('email');
      setData({
        phoneNumber: totalInfo.phoneNumber || ph1,
        email: totalInfo.email || email ,
      });
    }
  }, [totalInfo]);

  return (
    <footer
      id="react-footer"
      className={footerClass || "react-footer home-main"}
    >
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 md-mb-30">
              <div className="footer-widget footer-widget-1">
                <div className="footer-logo white">
                  <Link to="/" className="logo-text">
                    <img src={Logo} alt="Footer Logo" />
                  </Link>
                </div>
                <h5 className="footer-subtitle">
                  Practice a little every day to see big results! <br />
                  Don’t wait to start your French learning journey! Download Your French Teachers App now and unlock a world of opportunities.
                  Bonjour, French fluency!
                </h5>
                <ul className="footer-address">
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <a href={`#`}>(+95){data.phoneNumber}</a>
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <a href={`#`}>
                      {data.email || 'info@yourfrenchteachers.com'}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 md-mb-30">
              <div className="footer-widget footer-widget-2">
                <h3 className="footer-title">About Us</h3>
                <div className="footer-menu">
                  <ul>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/instructor">Instructor</Link></li>
                    <li><Link to="/blog">Blog</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                    <li><Link to="/quotation">Quotation</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 md-mb-30">
              <div className="footer-widget footer-widget-3">
                <h3 className="footer-title">Courses</h3>
                <div className="footer-menu">
                  <ul>
                    <li><Link to="/adult">Adult</Link></li>
                    <li><Link to="/kid">Kid</Link></li>
                    <li><Link to="/native">Native</Link></li>
                    <li><Link to="/video">Video</Link></li>
                    <li><Link to="/books">Books</Link></li>
                    <li><Link to="/level-test">Level Test</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-widget footer-widget-4">
                <h3 className="footer-title">Download Our App</h3>
                <div className="slider-btn wow animate__fadeInUp" data-wow-duration="1.2s">
                  <a href="https://apps.apple.com/us/app/your-french-teachers/id6742703203"  target="_blank" className="btn btn-dark btn-lg px-3 py-2 me-3 me-sm-3 me-lg-4 mb-3">
                    <img src="../appstore-light.svg" className="light-mode-img" width={124} alt="App Store" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.khinezin.yftapp"  target="_blank" className="btn btn-dark btn-lg px-3 py-2 mb-3">
                    <img src="../googleplay-light.svg" className="light-mode-img" width={139} alt="Google Play" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <div className="react-copy-left">
            © {new Date().getFullYear()} <Link to="/">Your French Teachers.</Link> All Rights Reserved. Build by <Link to="https://ojodigitalmarketing.com/" className="eeaio-text">OJO</Link>
          </div>
          <Link to="https://ojodigitalmarketing.com/" className="eeaio-logo">
            <img src={eeaio} alt="Footer Logo" />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
